type VipType = 1 | 2 | 3 | 4;
const VIP_TYPE_MAP: Record<VipType, string> = {
    1: 'AI会员',
    2: '基础AI会员',
    3: '标准AI会员',
    4: '高级AI会员',
};

// 渠道码
const CHANNEL_CODE = {
    PS: '18', // ps
    SU: '19', // sketchUp
    MAX: '20', // 3dMax
};

export {
    CHANNEL_CODE,
    type VipType,
    VIP_TYPE_MAP,
}